import { Injectable } from '@angular/core';
import { Http, Response }  from '@angular/http';
import { AuthHttp, AuthConfig} from 'angular2-jwt';
import { Observable }  from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import { StoreService }  from '../store/store.service';

declare const moment: any;

@Injectable()
export class LogService {

    logs: any[ ] = [ ];

    private static extractData(res: Response) {
        let body = res.json();
        return body || [ ];
    }

    private static handleError (error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead

        return Observable.throw(errMsg);
    }

    constructor(public http: Http, public authHttp: AuthHttp, private store: StoreService) { }

    getLogs(idToken: string, prefix: string, customer: string): Observable<any> {

        // Note that we convert the offset to UTC
        if (!prefix) {
            prefix = moment.utc().subtract(2, 'hours').format('YYYY/MM/DD/HH');
        } else {
            // TODO: need to convert prefix to UTC
        }
        //XXX: HACK - convert demo1 to ajithome1 fornow
        if (customer == 'demo1') customer = 'ajithome1';
        
        const json_token = { prefix: prefix };

        const apiConfig = this.store.get('apiConfig');
        apiConfig.headers["Authorization"] = idToken;

        return this.http.post(apiConfig.rawLogsURL,
            JSON.stringify(json_token), { headers: apiConfig.headers })
            .map(LogService.extractData)
            .catch(LogService.handleError);

        // Mock request to a static logs data file
        // return this.http.get('assets/data/logs.json').map(LogService.extractData).catch(LogService.handleError);
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/log/log.service.ts